var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundNewAuth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_358_6911)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1512 0H0V982H1512V0Z",
    fill: "url(#paint0_linear_358_6911)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1374 1078.51C1475.62 1078.51 1558 998.253 1558 899.254C1558 800.255 1475.62 720 1374 720C1272.38 720 1190 800.255 1190 899.254C1190 998.253 1272.38 1078.51 1374 1078.51Z",
    fill: "url(#paint1_radial_358_6911)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    filter: "url(#filter0_f_358_6911)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.01 1053.16C1473.23 1053.16 1543.13 985.064 1543.13 901.065C1543.13 817.065 1473.23 748.97 1387.01 748.97C1300.79 748.97 1230.89 817.065 1230.89 901.065C1230.89 985.064 1300.79 1053.16 1387.01 1053.16Z",
    fill: "url(#paint2_radial_358_6911)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 257.508C101.62 257.508 184 177.253 184 78.254C184 -20.7452 101.62 -101 0 -101C-101.62 -101 -184 -20.7452 -184 78.254C-184 177.253 -101.62 257.508 0 257.508Z",
    fill: "url(#paint3_radial_358_6911)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    filter: "url(#filter1_f_358_6911)"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 232.159C99.2335 232.159 169.131 164.064 169.131 80.0646C169.131 -3.93469 99.2335 -72.0297 13.0101 -72.0297C-73.2132 -72.0297 -143.111 -3.93469 -143.111 80.0646C-143.111 164.064 -73.2132 232.159 13.0101 232.159Z",
    fill: "url(#paint4_radial_358_6911)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.16 258.736C1569.44 258.736 1635.33 194.548 1635.33 115.368C1635.33 36.188 1569.44 -28 1488.16 -28C1406.89 -28 1341 36.188 1341 115.368C1341 194.548 1406.89 258.736 1488.16 258.736Z",
    fill: "url(#paint5_radial_358_6911)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    filter: "url(#filter2_f_358_6911)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1498.57 238.461C1567.53 238.461 1623.44 183.999 1623.44 116.816C1623.44 49.6331 1567.53 -4.82944 1498.57 -4.82944C1429.61 -4.82944 1373.7 49.6331 1373.7 116.816C1373.7 183.999 1429.61 238.461 1498.57 238.461Z",
    fill: "url(#paint6_radial_358_6911)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1113.71 199.956C1104.16 208.354 1096.65 218.714 1091.72 230.286C1086.79 241.858 1084.55 254.354 1085.18 266.869C1087.06 305.246 1071.31 342.483 1043.41 369.665L1042.47 370.588C1026.19 386.275 1006.26 397.901 984.378 404.48C962.499 411.059 939.312 412.395 916.788 408.376C896.034 404.761 874.691 406.088 854.577 412.243C834.463 418.399 816.175 429.2 801.272 443.728C777.007 467.477 763.268 499.547 763.004 533.054C762.74 566.562 775.972 598.834 799.86 622.943C811.962 635.061 826.414 644.718 842.377 651.351C858.341 657.984 875.498 661.461 892.852 661.582C910.207 661.703 927.413 658.464 943.472 652.053C959.531 645.643 974.123 636.188 986.401 624.239C1001.44 609.604 1012.59 591.622 1018.89 571.846C1025.19 552.07 1026.45 531.097 1022.57 510.739C1014.1 466.039 1029.64 420.199 1062.65 388.048L1063.11 387.577C1091.17 360.238 1129.76 346.333 1169.43 347.57C1183.67 348.001 1197.8 345.02 1210.59 338.889C1223.37 332.758 1234.41 323.665 1242.74 312.407C1251.08 301.149 1256.44 288.071 1258.38 274.32C1260.31 260.569 1258.75 246.565 1253.84 233.538C1248.92 220.512 1240.8 208.859 1230.18 199.605C1219.56 190.35 1206.77 183.775 1192.94 180.458C1179.11 177.141 1164.65 177.182 1150.83 180.578C1137.02 183.974 1124.27 190.621 1113.71 199.936V199.956Z",
    fill: "url(#paint7_linear_358_6911)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M426.711 590.956C417.165 599.354 409.653 609.714 404.72 621.286C399.786 632.858 397.554 645.354 398.185 657.869C400.06 696.246 384.315 733.483 356.413 760.665L355.466 761.588C339.185 777.275 319.258 788.901 297.378 795.48C275.498 802.059 252.312 803.395 229.788 799.376C209.034 795.761 187.691 797.088 167.577 803.243C147.463 809.399 129.175 820.2 114.271 834.728C90.0068 858.477 76.2677 890.547 76.0039 924.054C75.74 957.562 88.9725 989.834 112.86 1013.94C124.962 1026.06 139.414 1035.72 155.377 1042.35C171.341 1048.98 188.498 1052.46 205.852 1052.58C223.207 1052.7 240.413 1049.46 256.472 1043.05C272.531 1036.64 287.123 1027.19 299.401 1015.24C314.438 1000.6 325.589 982.622 331.891 962.846C338.192 943.07 339.454 922.097 335.568 901.739C327.101 857.039 342.644 811.199 375.646 779.048L376.11 778.577C404.172 751.238 442.759 737.333 482.433 738.57C496.674 739.001 510.805 736.02 523.586 729.889C536.368 723.758 547.41 714.665 555.743 703.407C564.076 692.149 569.445 679.071 571.379 665.32C573.313 651.569 571.754 637.565 566.837 624.538C561.92 611.512 553.796 599.859 543.179 590.605C532.561 581.35 519.775 574.775 505.941 571.458C492.106 568.141 477.648 568.182 463.834 571.578C450.02 574.974 437.273 581.621 426.711 590.936V590.956Z",
    fill: "url(#paint8_linear_358_6911)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M356.299 288.719C361.111 284.484 364.897 279.26 367.383 273.424C369.869 267.589 370.993 261.288 370.673 254.978C370.287 245.394 371.956 235.837 375.573 226.916C379.189 217.995 384.675 209.907 391.68 203.167L392.164 202.696C400.373 194.777 410.426 188.909 421.466 185.592C432.506 182.275 444.205 181.607 455.567 183.645C469.424 186.05 483.707 184.078 496.331 178.016C508.956 171.955 519.263 162.122 525.747 149.952C532.23 137.782 534.553 123.912 532.374 110.365C530.195 96.8186 523.63 84.3048 513.636 74.6497C503.642 64.9946 490.743 58.7035 476.82 56.6943C462.897 54.6852 448.68 57.0631 436.242 63.4811C423.804 69.8992 413.797 80.0214 407.681 92.3709C401.565 104.72 399.66 118.651 402.244 132.13C404.271 143.258 403.496 154.7 399.984 165.472C396.473 176.245 390.33 186.026 382.084 193.976L381.842 194.212C374.803 200.968 366.415 206.245 357.198 209.714C347.981 213.184 338.13 214.773 328.257 214.382C321.077 214.164 313.952 215.666 307.508 218.756C301.063 221.846 295.495 226.43 291.293 232.105C287.091 237.78 284.383 244.374 283.407 251.306C282.431 258.239 283.216 265.299 285.694 271.868C288.172 278.436 292.267 284.311 297.62 288.977C302.972 293.644 309.418 296.96 316.393 298.633C323.368 300.306 330.657 300.287 337.622 298.575C344.587 296.864 351.014 293.513 356.34 288.817L356.299 288.719Z",
    fill: "url(#paint9_linear_358_6911)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M932.87 788.154C928.058 792.39 924.272 797.614 921.786 803.449C919.3 809.285 918.177 815.586 918.496 821.896C918.883 831.48 917.214 841.037 913.597 849.958C909.98 858.878 904.494 866.966 897.49 873.706L897.006 874.178C888.796 882.096 878.743 887.964 867.704 891.281C856.664 894.599 844.965 895.266 833.603 893.228C819.746 890.824 805.463 892.796 792.838 898.857C780.213 904.918 769.907 914.752 763.423 926.922C756.939 939.092 754.617 952.962 756.796 966.509C758.974 980.055 765.54 992.569 775.533 1002.22C785.527 1011.88 798.427 1018.17 812.35 1020.18C826.272 1022.19 840.49 1019.81 852.928 1013.39C865.366 1006.97 875.373 996.852 881.489 984.503C887.605 972.153 889.51 958.223 886.926 944.744C884.898 933.616 885.674 922.174 889.185 911.401C892.697 900.629 898.839 890.848 907.086 882.898L907.328 882.662C914.366 875.905 922.754 870.629 931.972 867.159C941.189 863.69 951.04 862.101 960.913 862.492C968.093 862.71 975.217 861.208 981.662 858.118C988.107 855.028 993.674 850.444 997.876 844.769C1002.08 839.093 1004.79 832.5 1005.76 825.567C1006.74 818.634 1005.95 811.574 1003.48 805.006C1001 798.438 996.902 792.563 991.55 787.896C986.198 783.23 979.751 779.914 972.777 778.241C965.802 776.567 958.513 776.587 951.548 778.298C944.583 780.01 938.156 783.36 932.83 788.056L932.87 788.154Z",
    fill: "url(#paint10_linear_358_6911)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_358_6911",
    x: 1223.89,
    y: 741.97,
    width: 326.243,
    height: 318.189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_358_6911"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_358_6911",
    x: -150.111,
    y: -79.0297,
    width: 326.242,
    height: 318.189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_358_6911"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_358_6911",
    x: 1366.7,
    y: -11.8294,
    width: 263.732,
    height: 257.291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_358_6911"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_358_6911",
    x1: 0,
    y1: 0,
    x2: 1534.94,
    y2: 944.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552083,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F7FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1459.49 882.958) rotate(131.634) scale(234.991 235.791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0569FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1502.24 843.124) rotate(145.813) scale(244.903 242.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.4949 61.9581) rotate(131.634) scale(234.991 235.791)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0569FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.242 22.1239) rotate(145.813) scale(244.903 242.627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1556.54 102.334) rotate(131.634) scale(187.946 188.586)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0569FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_358_6911",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1590.73 70.4749) rotate(145.813) scale(195.874 194.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_358_6911",
    x1: 776.995,
    y1: 620.023,
    x2: 1219.99,
    y2: 207.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#EDF6FF",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B7DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_358_6911",
    x1: 89.9948,
    y1: 1011.02,
    x2: 532.995,
    y2: 598.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#EDF6FF",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B7DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_358_6911",
    x1: 290.056,
    y1: 278.914,
    x2: 513.459,
    y2: 70.8103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#EDF6FF",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B7DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_358_6911",
    x1: 999.114,
    y1: 797.96,
    x2: 775.711,
    y2: 1006.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#EDF6FF",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#B7DCFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_358_6911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundNewAuth);
export default __webpack_public_path__ + "static/media/background-new-auth.cd66ca629be47a827864b50b113ed430.svg";
export { ForwardRef as ReactComponent };